<script setup>
import AdviceModal from "@/components/9may/AdviceModal.vue";
import CanvasModal from "@/components/9may/CanvasModal.vue";
import CongratulationModal from "@/components/9may/CongratulationModal.vue";
import FireworkModal from "@/components/9may/FireworkModal.vue";
import QuizModal from "@/components/9may/QuizModal.vue";
import ReviewModal from "@/components/9may/ReviewModal.vue";
import { onBeforeUnmount, onMounted, ref } from 'vue';
import { useStore } from "vuex";

const store = useStore();

const showCanvas = ref(false);

const eventList = ref([]);

const fireworkTemp = ref(null);
const firework = ref(null);
const showQuiz = ref(false);
const showAdvice = ref(false);
const showReview = ref(false);
const showCongratulation = ref(false);

const forWhom = ref('_mama');

function startGame() {
  showCanvas.value = true;
}

function onShowAdvice() {
  showReview.value = false;
  showAdvice.value = true;
}

function onShowReview() {
  showQuiz.value = false;
  showReview.value = true;
}

function showSelectForWhom({ detail }) {
  console.log(detail)
  showCanvas.value = false;
  showCongratulation.value = true;
  fireworkTemp.value = detail;
}

function runQuiz() {
  firework.value = null;
  showQuiz.value = true;
}

function runVideo(whom) {
  forWhom.value = whom;
  showCongratulation.value = false;
  firework.value = fireworkTemp.value;
  fireworkTemp.value = null;
}

function onCloseReview() {
  showReview.value = false;
}

async function init() {
  store
  .dispatch("fetchCalendarEventsRecommendation", {
    type: "",
    page: 1,
    limit: 100,
  }).then((data) => eventList.value = data)
}

init();

onMounted(() => {
  document.addEventListener('run-win', startGame)
  document.addEventListener('firework', showSelectForWhom);
});

onBeforeUnmount(() => {
  document.removeEventListener('run-win', startGame)
  document.removeEventListener('firework', showSelectForWhom);
});
</script>

<template>
  <div class="description container">
    <div class="description-content">
      <p class="description__title">
        Сегодня вам предстоит стать режиссёром собственного праздничного шоу на
        Центральной аллее ВДНХ
      </p>
      <p class="description__subtitle">
        Настройте оборудование, синхронизируйте залпы салюта с музыкой и
        выберите уникальные фигуры для впечатляющего шоу в небе над столицей.
      </p>
      <div class="description-videos">
        <video
          preload="auto"
          loop
          autoplay
          muted
          playsinline
          webkit-playsinline
          src="@/assets/9may/FireworkGif.webm"
          class="description-videos__element"></video>
        <video
          preload="auto"
          loop
          autoplay
          muted
          playsinline
          webkit-playsinline
          src="@/assets/9may/FireworkGif2.webm"
          class="description-videos__element"></video>
      </div>
      <div class="description-info">
        <p class="description-info__text">
          Видео вашего салюта вы сможете отправить друзьям и близким, чтобы
          разделить с ними радость Дня Победы!
        </p>
        <img
          src="@/assets/9may/statue.svg"
          alt=""
          class="description-info__img" />
      </div>
      <video
        preload="auto"
        loop
        autoplay
        muted
        playsinline
        webkit-playsinline
        src="https://meta-vdnh-s3.mos.ru/static_content/video/Demo_salut.mp4"
        class="description__photo"></video>
      <p class="description__end">Ваш салют станет частью великой традиции!</p>
    </div>
    <button class="description__start link" @click="startGame">Начать</button>

    <div v-if="showCanvas">
      <CanvasModal v-model="showCanvas" @video="showSelectForWhom" />
    </div>
    <CongratulationModal
      :model-value="forWhom"
      :show="showCongratulation"
      @close="showCongratulation"
      @update:modelValue="runVideo"
    />
    <FireworkModal :firework="firework" :whom="forWhom" @end="runQuiz"  />
    <QuizModal v-model="showQuiz" @next="onShowReview" />
    <ReviewModal
      :show="showReview"
      @close="onCloseReview"
      @next="onShowAdvice"
    />
    <AdviceModal v-model="showAdvice" :events="eventList" />
  </div>
</template>

<style scoped lang="scss">
.description {
  margin-top: 32px;

  &-content {
    padding: 37px 24px;
    background: #00288c;
    border-radius: 32px;
    width: 100%;
  }
  &__title {
    font-weight: 700;
    font-size: 40px;
    line-height: 130%;
    letter-spacing: 0.01em;
    color: #fff;
  }
  &__subtitle {
    margin-top: 25px;
    font-weight: 400;
    font-size: 32px;
    line-height: 130%;
    letter-spacing: 0.01em;
    color: #fff;
  }
  &-videos {
    margin-top: 49px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 28px;
    &__element {
      width: 100%;
      border-radius: 32px;
      position: relative;
      height: 456px;
      object-fit: cover;
      background: #000;
    }
  }
  &-info {
    margin-top: 26px;
    display: flex;
    align-items: center;
    gap: 16px;
    &__text {
      font-weight: 700;
      font-size: 40px;
      line-height: 100%;
      color: #fff;
      max-width: 960px;
    }
    &__img {
      display: flex;
      flex-shrink: 0;
      margin-left: auto;
      margin-right: 58px;
    }
  }
  &__photo {
    margin-top: 30px;
    width: 100%;
    height: auto;
    border-radius: 32px;
    position: relative;
    background: #000;
  }
  &__end {
    margin-top: 49px;
    font-weight: 700;
    font-size: 40px;
    line-height: 112%;
    color: #fff;
  }
  &__start {
    margin-top: 20px;
    justify-content: center;
    padding: 14px;
    font-size: 20px;
    width: 100%;
  }
  @media (max-width: 1100px) {
    &__title {
      font-size: 24px;
    }
    &__subtitle {
      margin-top: 20px;
      font-size: 16px;
    }
    &-videos {
      margin-top: 30px;
      display: flex;
      flex-direction: column;
      gap: 16px;
      &__element {
        width: 100%;
        height: 200px;
      }
    }
    &-info {
      margin-top: 26px;
      display: flex;
      align-items: center;
      gap: 16px;
      &__text {
        font-size: 24px;
        max-width: 960px;
      }
      &__img {
        margin-right: 0;
        width: 80px;
      }
    }
    &__end {
      margin-top: 30px;
      font-size: 24px;
    }
    &__start {
      margin-top: 20px;
      justify-content: center;
      padding: 14px;
      font-size: 20px;
      width: 100%;
    }
  }
}
.desk {
  @media (max-width: 1000px) {
    display: none !important;
  }
}

.mob {
  display: none !important;
  @media (max-width: 1000px) {
    display: flex !important;
  }
}
</style>
